// @flow
import * as React from 'react';
import Box from 'sail/Box';
import './FlowChart.scss';

type FlowChartGroupProps = {|
  children: React.Node,
|};

export const FlowChartGroup = ({children}: FlowChartGroupProps) => {
  return (
    <>
      <Box className="FlowChartGroup-border" />
      <Box flex>{children}</Box>
    </>
  );
};
